import React from 'react';
import "../admin/style/style-pc.css";
import "../admin/style/style-mob.css";
import img from "../../resources/logo.webp";
import { useNavigate } from 'react-router-dom';
import { host } from "../../config/Config";
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

export const MyAppointments = () => {
    const navigate = useNavigate();
    const [haircuts, setHaircuts] = React.useState([]);
    const [expanded, setExpanded] = React.useState(null);
    const [toDeleteId, setToDeleteId] = React.useState("");
    const [toDeleteTime, setToDeleteTime] = React.useState("");
    const [toDeleteDate, setToDeleteDate] = React.useState("");
    const [openDialog, setOpenDialog] = React.useState(false); 

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    React.useEffect(() => {
      const fetchHaircuts = async () => {
        try {
            const response = await fetch(`${host}/api/v1/reservations/me`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem("zajednica-token")}`,
                },
            });

          const data = await response.json();
          setHaircuts(data);
        } catch (error) {
          setHaircuts([]);
        }
      };
  
      fetchHaircuts();
    }, []);

    const handlePocetna = () => {
        navigate("/profile");
    }

    const handleObrisiTermin = async () => {
        try {
          const token = localStorage.getItem("zajednica-token");
          const response = await fetch(`${host}/api/v1/reservations/cancel/${toDeleteId}`, {
            method: "DELETE",
            headers: {
              "Authorization": `Bearer ${token}`,
              "Content-Type": "application/json"
            }
          });
    
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
    
          setOpenDialog(false);
    
            try {
                const response = await fetch(`${host}/api/v1/reservations/me`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${localStorage.getItem("zajednica-token")}`,
                    },
                });

                const data = await response.json();
                setHaircuts(data);
            } catch (error) {
                setHaircuts([]);
            }
        } catch (error) {
          console.error("Error deleting haircut:", error);
        }
      };

    const handleExpand = (index) => {
        setExpanded(expanded === index ? null : index);
    };

    return (
        <div className="barber-zajednica-admin-page">
            <div className='barber-zajednica-admin-background'></div>
            <h2 style={{marginTop: "30px", color:"white"}}>Rezervisani termini</h2>
            <div 
                style={{
                    width: "90%", 
                    height: "53vh", 
                    border: "2px solid gray",
                    borderRadius: "15px",
                    marginTop: "20px",
                    overflowY: "auto", 
                    zIndex: "150"
                }}
            >
                {haircuts.map((haircut, index) => (
                    <div
                        key={index}
                        style={{borderBottom: "2px solid gray", paddingBottom:"10px"}}
                        onClick={() => handleExpand(index)}
                    >
                        <div style={{display: "flex", paddingLeft: "20px", paddingTop: "10px"}}>
                            <div style={{width: "83%"}}>
                                <div>Datum : {haircut.date}</div>
                                <div>Vreme : {haircut.time}</div>
                            </div>
                            <div style={{width: "17%", paddingTop: "18px"}}>
                                <KeyboardDoubleArrowDownIcon style={{position: "relative"}}></KeyboardDoubleArrowDownIcon>
                            </div>
                        </div>

                        <div 
                            className={`expandable-content ${expanded === index ? 'expanded' : ''}`}
                        >
                            {expanded === index && (
                                <div style={{marginTop: "0"}}>
                                    <div style={{marginLeft: "20px"}}>
                                    {haircut.haircut.split("#").filter(Boolean).map((style, index) => (
                                        <div key={index}>- {style}</div>
                                    ))}
                                        <div>Cena : {haircut.price} RSD</div>
                                    </div>
                                    <button 
                                        className="dugmence"
                                        style={{margin: "20px 0 10px 70px"}}
                                        onClick={(e) => {
                                            setToDeleteDate(haircut.date);
                                            setToDeleteTime(haircut.time);
                                            setToDeleteId(haircut.id);
                                            setOpenDialog(true);
                                        }}
                                    >
                                        Otkaži Termin
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                ))}
            </div>

            <button 
                onClick={handlePocetna}
                className="barber-zajednica-login-button-user"  
                style={{ marginTop: "30px", marginBottom: "0px", zIndex: "1000" }}
            >
                Nazad na Profil
            </button>
            <div className="barber-zajednica-admin-logo" style={{width: "210px"}}>
                <img src={img} />
            </div>

            <Dialog
                open={openDialog}
                onClose={handleCloseDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{`Da li ste sigurni da želite da otkažete termin ${toDeleteDate} u terminu ${toDeleteTime} ?`}</DialogTitle>
                <DialogContent>
                </DialogContent>
                <DialogActions>
                <Button onClick={handleCloseDialog} color="primary">
                    Ne
                </Button>
                <Button onClick={handleObrisiTermin} color="secondary">
                    Da
                </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};
